<div
  *ngIf="{
    banners: banners$ | async,
    styleClasses: styleClasses$ | async
  } as observables"
>
  <div class="banner-collection-holder" [ngClass]="observables.styleClasses">
    <ng-container *ngIf="observables?.styleClasses?.includes('banner-collection-blocks'); else default">
      <ng-container *ngFor="let banner of observables.banners.split(' ')">
        <ng-container
          [styleClassesOverride]="observables.styleClasses"
          [cxComponentWrapper]="{
            flexType: 'BannerComponent',
            typeCode: 'BannerComponent',
            uid: banner
          }"
        ></ng-container>
      </ng-container>
    </ng-container>

    <ng-template #default>
      <ng-container
        [styleClassesOverride]="observables.styleClasses"
        [cxComponentWrapper]="{
          flexType: 'BannerComponent',
          typeCode: 'BannerComponent',
          uid: getRandomUid(observables.banners)
        }"
      ></ng-container>
    </ng-template>
  </div>
</div>
